import { Link } from "react-router-dom";
import { navLinks, siteMeta, contact } from "@/content/siteContent";

export const Footer = () => {
  return (
    <footer className="border-t border-ink/10" data-testid="site-footer">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 px-6 py-12 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <p className="text-sm font-bold tracking-tight">{siteMeta.name}</p>
          <p className="mt-1 text-sm text-muted">{siteMeta.title}</p>
        </div>
        <nav aria-label="Footer">
          <ul className="flex flex-wrap gap-x-6 gap-y-2">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="editorial-link text-sm text-muted"
                  data-testid={`footer-${l.label.toLowerCase()}-link`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="flex flex-col gap-2 text-sm">
          <a
            href={`mailto:${contact.email}`}
            className="editorial-link text-muted"
            data-testid="footer-email-link"
          >
            {contact.email}
          </a>
          <a
            href={contact.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="editorial-link text-muted"
            data-testid="footer-linkedin-link"
          >
            LinkedIn
          </a>
        </div>
      </div>
      <div className="border-t border-ink/10">
        <p className="mx-auto max-w-6xl px-6 py-5 text-xs text-muted">
          © {new Date().getFullYear()} {siteMeta.name}. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
